import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import LogRocket from "logrocket";
import { PublicClientApplication } from "@azure/msal-browser";
import { MsalProvider } from "@azure/msal-react";
import { msalConfig } from "./authConfig";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";

const queryClient = new QueryClient();
// Initialize MSAL instance
const msalInstance = new PublicClientApplication(msalConfig);

console.log("process.env.NODE_ENV", process.env.NODE_ENV);

if (
  process.env.NODE_ENV === "production" &&
  process.env.REACT_APP_LOG_ROCKET_KEY
) {
  LogRocket.init(process.env.REACT_APP_LOG_ROCKET_KEY);
}

// Wait for MSAL to initialize before rendering
msalInstance.initialize().then(() => {
  const root = ReactDOM.createRoot(document.getElementById("root"));
  root.render(
    <React.StrictMode>
      <QueryClientProvider client={queryClient}>
        <MsalProvider instance={msalInstance}>
          <App />
        </MsalProvider>
      </QueryClientProvider>
    </React.StrictMode>
  );
});

reportWebVitals();
